import React from 'react'
import moment from 'moment'

import LanguagePicker from 'src/components/LanguagePicker'

import { ContainerToodo, WrapFooter } from './styles'

const year = moment().format('YYYY')

export default function Footer() {
  return (
    <WrapFooter>
      <ContainerToodo>toodo Sistemas ©{year}</ContainerToodo>
      <LanguagePicker />
    </WrapFooter>
  )
}
